import type { UnaryOutput } from '@improbable-eng/grpc-web/dist/typings/unary';
import { errorCodeTranslation } from '../../grpc/errorCodeTranslation';

export function grpcError(functionName: string,args: IArguments, res: UnaryOutput<unknown>) {
  return ({
    functionName,
    arguments: args,
    response: {
      status: res.status,
      statusMessage: errorCodeTranslation[res.statusMessage] || res.statusMessage,
      rawStatusMessage: res.statusMessage,
      message: res.message?.toObject() || res.message,
    }
  })
}
